<template>
  <div class="page-col">
    <div class="page-main">
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-2" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center py-1 px-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #aa6c39 0%, #d59a3d 100%);">
            <i class="fa fa-industry text-white"></i>
          </div>
          <div>
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'" style="font-size: 1.15rem;">Processo de Produção por Fórmula</h4>
            <small class="text-muted small">Listagem e acompanhamento dos processos em lote único</small>
          </div>
        </div>

        <div class="list-header-actions d-flex align-items-center flex-wrap gap-2 py-1 px-3 justify-content-end">
          <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2 flex-wrap">
            <b-button-group class="mr-2 d-none d-lg-inline-flex">
              <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.focus title="Filtros avançados">
                <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro" v-b-tooltip.focus title="Limpar filtros">
                <i class="fa fa-ban"></i>
              </b-button>
            </b-button-group>

            <div class="search-pill-segment d-flex align-items-center px-2 border-left mr-2 form-search-wrapper">
              <b-form-input
                v-model="textoPesquisa"
                placeholder="Buscar lote final..."
                class="shadow-xs"
                style="font-size: 0.9rem;"
                @keydown.enter.native="pesquisar">
              </b-form-input>
            </div>

            <div class="search-pill-segment d-flex align-items-center px-2 border-left mr-2 search-pill-date-wrapper">
              <CecInputData v-model="dt1" class="mx-1 search-pill-date" @keydown.enter.native="pesquisar" />
              <span class="text-muted mx-1 d-none d-sm-inline">até</span>
              <CecInputData v-model="dt2" class="mx-1 search-pill-date" @keydown.enter.native="pesquisar" />
            </div>

            <div class="search-pill-segment d-flex align-items-center px-2 border-left mr-2 search-pill-type-wrapper">
              <b-form-select v-model="tipoData" :options="tipoDataOptions" class="border-0 bg-transparent py-0 search-pill-select"></b-form-select>
            </div>

            <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white btn-filtrar-responsive" :disabled="isBusy" @click="pesquisar">
              <i class="fa fa-search mr-1"></i>
              <span class="d-none d-sm-inline">FILTRAR</span>
            </b-button>
          </div>

          <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm btn-adicionar-responsive" @click.stop.prevent="novo">
            <i class="fa fa-plus-circle mr-1"></i>
            <span class="d-none d-sm-inline">Novo Processo</span>
          </b-button>
        </div>
      </div>

      <b-collapse v-model="filtroAvancado">
        <div class="px-4 pb-4">
          <div class="card card-filter-premium compact-filter p-3 border-0 shadow-sm">
            <b-row align-v="end">
              <b-col md="6">
                <label class="small font-weight-bold text-muted">Fórmula</label>
                <ProducaoFormulaProcessoFormulaDropDown
                  v-model="filtroFormulaId"
                  :idInicial="filtroFormulaId"
                  placeholder="Pesquise a fórmula...">
                </ProducaoFormulaProcessoFormulaDropDown>
              </b-col>
              <b-col md="3">
                <label class="small font-weight-bold text-muted">Situação</label>
                <b-form-select v-model="filtroSituacao" class="shadow-xs rounded-pill">
                  <b-form-select-option v-for="opt in situacaoOptions" :key="opt.valueLabel" :value="opt.value">
                    {{ opt.text }}
                  </b-form-select-option>
                </b-form-select>
              </b-col>
              <b-col md="3">
                <label class="small font-weight-bold text-muted d-block">&nbsp;</label>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-collapse>

      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table
              ref="tbl"
              class="mb-0 table-finance"
              :head-variant="isDark ? 'dark' : 'light'"
              :dark="isDark"
              show-empty
              empty-text="Nenhum processo encontrado"
              responsive
              :sticky-header="stickyHeight"
              hover
              small
              :busy.sync="isBusy"
              :items="itensFiltrados"
              :fields="colunas"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="clicarLinha"
              @row-dblclicked="edit"
              :tbody-tr-class="rowClassSelecionado">
              <template #head(ID)>
                <SetFilter label="ID" v-model="filtros.ID" :options="opcoes.ID" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(LOTE)>
                <SetFilter label="Lote" v-model="filtros.LOTE" :options="opcoes.LOTE" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(FORMULA_DESCRICAO)>
                <SetFilter label="Fórmula" v-model="filtros.FORMULA_DESCRICAO" :options="opcoes.FORMULA_DESCRICAO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(PRODUTO_CODIGONOME)>
                <SetFilter label="Produto Final" v-model="filtros.PRODUTO_CODIGONOME" :options="opcoes.PRODUTO_CODIGONOME" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(SITUACAO_LABEL)>
                <SetFilter label="Situação" v-model="filtros.SITUACAO_LABEL" :options="opcoes.SITUACAO_LABEL" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #cell(QUANT_PREVISTA)="row">
                <span class="text-right d-block">{{ formatarNumero(row.item.QUANT_PREVISTA) }}</span>
              </template>

              <template #cell(RESERVA_RESUMO)="row">
                <div class="text-center">
                  <b-badge v-if="String(row.item.SITUACAO || 'L') === 'L' && Number(row.item.ITENS_RESERVADOS || 0) > 0" variant="info" pill class="px-3 py-2 reserva-badge">
                    {{ formatarNumero(row.item.RESERVA_QUANT_TOTAL) }} / {{ formatarInteiro(row.item.RESERVA_PECAS_TOTAL) }} pçs
                  </b-badge>
                  <small v-if="String(row.item.SITUACAO || 'L') === 'L' && Number(row.item.ITENS_RESERVADOS || 0) > 0" class="text-muted d-block mt-1">
                    {{ formatarInteiro(row.item.ITENS_RESERVADOS) }} item(ns)
                  </small>
                  <span v-else class="text-muted small">Reserva liberada</span>
                </div>
              </template>

              <template #cell(SITUACAO_LABEL)="row">
                <b-badge :variant="getVariantStatus(row.item.SITUACAO)" pill>{{ row.item.SITUACAO_LABEL }}</b-badge>
              </template>

              <template #cell(actions)="item">
                <div class="d-flex justify-content-center gap-1">
                  <b-button type="button" @click.stop.prevent="abrirApontamento(item.item)" :variant="String(item.item.SITUACAO || 'L') === 'F' ? 'outline-secondary' : 'outline-success'" pill class="btn-icon-only shadow-sm" :title="String(item.item.SITUACAO || 'L') === 'F' ? 'Consultar apontamento' : 'Apontar produção'" v-b-tooltip.focus>
                    <i :class="String(item.item.SITUACAO || 'L') === 'F' ? 'fa fa-eye' : 'fa fa-clipboard'"></i>
                  </b-button>
                  <b-button type="button" @click.stop.prevent="edit(item.item)" variant="soft-primary" pill class="btn-icon-only shadow-sm" :title="String(item.item.SITUACAO || 'L') === 'F' ? 'Consultar processo' : 'Editar'" v-b-tooltip.focus>
                    <i :class="String(item.item.SITUACAO || 'L') === 'F' ? 'fa fa-eye' : 'fa fa-pencil'"></i>
                  </b-button>
                  <b-button v-if="String(item.item.SITUACAO || 'L') === 'F'" type="button" @click.stop.prevent="reabrir(item.item)" variant="outline-warning" pill class="btn-icon-only shadow-sm" title="Reabrir processo" v-b-tooltip.focus>
                    <i class="fa fa-unlock"></i>
                  </b-button>
                  <b-button v-if="String(item.item.SITUACAO || 'L') === 'L'" type="button" @click.stop.prevent="abrirModalCancelar(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Cancelar" v-b-tooltip.focus>
                    <i class="fa fa-ban"></i>
                  </b-button>
                </div>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-modal
      ref="modalCancelar"
      title="Cancelar Processo"
      ok-variant="danger"
      ok-title="Sim, cancelar"
      cancel-title="Não"
      centered
      @ok="cancelar">
      <div v-if="itemCancelar">
        <p class="mb-2">Deseja realmente cancelar este processo de produção por fórmula?</p>
        <div class="card bg-light">
          <div class="card-body">
            <p class="mb-1"><strong>ID:</strong> {{ itemCancelar.ID }}</p>
            <p class="mb-1"><strong>Lote:</strong> {{ itemCancelar.LOTE }}</p>
            <p class="mb-1"><strong>Fórmula:</strong> {{ itemCancelar.FORMULA_DESCRICAO }}</p>
            <p class="mb-0"><strong>Produto Final:</strong> {{ itemCancelar.PRODUTO_CODIGONOME }}</p>
          </div>
        </div>
        <div class="mt-3">
          <label class="font-weight-bold">Motivo do cancelamento</label>
          <b-form-textarea v-model="motivoCancelamento" rows="3" placeholder="Informe o motivo, se necessário"></b-form-textarea>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SetFilter from '@/components/Cec/SetFilter.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import Tools from '@/tools/tools'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import ProducaoFormulaProcessoFormulaDropDown from './ProducaoFormulaProcessoFormulaDropDown.vue'

export default {
  components: {
    SetFilter,
    CecInputData,
    ProducaoFormulaProcessoFormulaDropDown
  },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    useExternalPaging: false,
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'LOTE', type: 'string', label: 'Lote' },
      { key: 'FORMULA_DESCRICAO', type: 'string', label: 'Fórmula' },
      { key: 'PRODUTO_CODIGONOME', type: 'string', label: 'Produto Final' },
      { key: 'SITUACAO_LABEL', type: 'string', label: 'Situação' }
    ]
  })],
  data() {
    return {
      isBusy: false,
      filtroAvancado: false,
      itemCancelar: null,
      motivoCancelamento: '',
      tipoDataOptions: [
        { value: 'C', text: 'Data de cadastro' },
        { value: 'P', text: 'Data do processo' }
      ],
      situacaoOptions: [
        { value: 'L', valueLabel: 'L', text: 'Em lançamento' },
        { value: 'C', valueLabel: 'C', text: 'Cancelados' },
        { value: 'F', valueLabel: 'F', text: 'Finalizados' },
        { value: '', valueLabel: 'TODOS', text: 'Todos' }
      ],
      colunas: [
        { key: 'ID', label: 'ID', sortable: true, class: 'text-center', thStyle: { width: '80px' } },
        { key: 'LOTE', label: 'Lote Final', sortable: true, thStyle: { width: '130px' } },
        { key: 'FORMULA_DESCRICAO', label: 'Fórmula', sortable: true },
        { key: 'PRODUTO_CODIGONOME', label: 'Produto Final', sortable: true },
        { key: 'CENTRO_CONSUMO_CODIGONOME', label: 'Centro Consumo', sortable: true },
        { key: 'CENTRO_PRODUCAO_CODIGONOME', label: 'Centro Produção', sortable: true },
        { key: 'QUANT_PREVISTA', label: 'Qtd. Prevista', sortable: true, class: 'text-right', thStyle: { width: '130px' } },
        { key: 'PECAS_PREVISTA', label: 'Peças', sortable: true, class: 'text-center', thStyle: { width: '90px' } },
        { key: 'TOTAL_ITENS', label: 'Itens', sortable: true, class: 'text-center', thStyle: { width: '90px' } },
        { key: 'RESERVA_RESUMO', label: 'Reserva Ativa', class: 'text-center', thStyle: { width: '170px' } },
        { key: 'SITUACAO_LABEL', label: 'Situação', sortable: true, class: 'text-center', thStyle: { width: '120px' } },
        { key: 'actions', label: 'Ações', class: 'text-center', thStyle: { width: '120px' } }
      ]
    }
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    ...mapGetters('producaoFormulaProcesso', [
      'LISTA',
      'FILTRO_LOTE',
      'FILTRO_FORMULA_ID',
      'FILTRO_SITUACAO',
      'DT1',
      'DT2',
      'TIPO_DATA',
      'REGISTRO_SELECIONADO_ID',
      'RECARREGAR_LISTA'
    ]),
    lista: {
      get() { return this.LISTA },
      set(v) { this.$store.commit('producaoFormulaProcesso/SET_LISTA', v) }
    },
    textoPesquisa: {
      get() { return this.FILTRO_LOTE },
      set(v) { this.$store.commit('producaoFormulaProcesso/SET_FILTRO_LOTE', v) }
    },
    filtroFormulaId: {
      get() { return this.FILTRO_FORMULA_ID },
      set(v) { this.$store.commit('producaoFormulaProcesso/SET_FILTRO_FORMULA_ID', v) }
    },
    filtroSituacao: {
      get() { return this.FILTRO_SITUACAO },
      set(v) { this.$store.commit('producaoFormulaProcesso/SET_FILTRO_SITUACAO', v) }
    },
    dt1: {
      get() { return this.DT1 },
      set(v) { this.$store.commit('producaoFormulaProcesso/SET_DT1', v) }
    },
    dt2: {
      get() { return this.DT2 },
      set(v) { this.$store.commit('producaoFormulaProcesso/SET_DT2', v) }
    },
    tipoData: {
      get() { return this.TIPO_DATA },
      set(v) { this.$store.commit('producaoFormulaProcesso/SET_TIPO_DATA', v) }
    }
  },
  mounted() {
    this.carregarTela()
  },
  activated() {
    if (this.RECARREGAR_LISTA) {
      this.carregarTela()
      this.$store.commit('producaoFormulaProcesso/SET_RECARREGAR_LISTA', false)
    }
  },
  methods: {
    formatarNumero(valor) {
      return Number(valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatarInteiro(valor) {
      return Number(valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
    },
    getVariantStatus(situacao) {
      if (String(situacao || 'L') === 'C') return 'danger'
      if (String(situacao || 'L') === 'F') return 'success'
      return 'warning'
    },
    clicarLinha(item) {
      this.$store.commit('producaoFormulaProcesso/SET_REGISTRO_SELECIONADO_ID', item.ID)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      return item.ID === this.REGISTRO_SELECIONADO_ID ? 'cec-row-selected' : ''
    },
    novo() {
      this.$router.push('/producao/formula-processo/add')
    },
    edit(item) {
      this.$router.push(`/producao/formula-processo/edit/${item.ID}`)
    },
    abrirApontamento(item) {
      if (String(item.SITUACAO || 'L') === 'C') {
        this.$bvToast.toast('Processos cancelados não possuem apontamento disponível para consulta', {
          title: 'Aviso',
          variant: 'warning',
          solid: true
        })
        return
      }

      this.$router.push(`/producao/formula-processo/apontamento/${item.ID}`)
    },
    async reabrir(item) {
      const confirmar = await this.$bvModal.msgBoxConfirm(
        'A reabertura vai apenas desfazer a finalização e voltar o processo para lançamento. Deseja continuar?',
        {
          title: 'Reabrir processo',
          okTitle: 'Reabrir',
          cancelTitle: 'Voltar',
          okVariant: 'warning',
          cancelVariant: 'secondary',
          centered: true
        }
      )

      if (!confirmar) return

      this.isBusy = true
      try {
        await this.$http.post('/api/protected/producao-formula-processo/reabrir', {
          id: item.ID,
          login: window.localStorage.getItem('login') || 'SISTEMA'
        })

        this.$bvToast.toast('Processo reaberto com sucesso', {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        })

        await this.pesquisar()
      } catch (err) {
        this.$bvToast.toast(err?.response?.data || 'Erro ao reabrir processo', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.isBusy = false
      }
    },
    async carregarTela() {
      this.garantirDatasPadrao()
      await this.pesquisar()
    },
    garantirDatasPadrao() {
      const hoje = Tools.getDataAtual()
      if (!this.dt1) this.dt1 = hoje
      if (!this.dt2) this.dt2 = hoje
    },
    async pesquisar() {
      this.isBusy = true
      try {
        await this.$store.dispatch('producaoFormulaProcesso/GET_LISTA')
      } catch (err) {
        this.$bvToast.toast(err?.response?.data || 'Erro ao carregar processos', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.isBusy = false
      }
    },
    limparFiltro() {
      this.$store.commit('producaoFormulaProcesso/SET_LIMPAR')
      this.garantirDatasPadrao()
      this.pesquisar()
    },
    abrirModalCancelar(item) {
      if (String(item.SITUACAO || 'L') === 'C') {
        this.$bvToast.toast('Este processo já está cancelado', {
          title: 'Aviso',
          variant: 'warning',
          solid: true
        })
        return
      }
      this.itemCancelar = item
      this.motivoCancelamento = ''
      this.$refs.modalCancelar.show()
    },
    async cancelar() {
      try {
        await this.$http.post('/api/protected/producao-formula-processo/cancelar', {
          id: this.itemCancelar.ID,
          login: window.localStorage.getItem('login') || 'SISTEMA',
          motivo: this.motivoCancelamento
        })
        this.$bvToast.toast('Processo cancelado com sucesso', {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        })
        await this.pesquisar()
      } catch (err) {
        this.$bvToast.toast(err?.response?.data || 'Erro ao cancelar processo', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      }
    }
  }
}
</script>

<style scoped>
.list-header-actions {
  width: 100%;
  gap: 0.75rem;
}

.search-pill-responsive {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
}

.search-pill-segment {
  min-width: 0;
}

.form-search-wrapper {
  flex: 1 1 150px;
  min-width: 150px;
}

.search-pill-date-wrapper {
  flex: 0 1 390px;
  min-width: 360px;
}

.search-pill-date {
  flex: 1 1 170px;
  min-width: 165px;
}

.search-pill-type-wrapper {
  flex: 0 1 180px;
  min-width: 170px;
}

.search-pill-select {
  min-width: 150px;
}

.btn-filtrar-responsive {
  flex: 0 0 auto;
  white-space: nowrap;
}

.btn-adicionar-responsive {
  flex: 0 0 auto;
}

.table-finance tbody td {
  vertical-align: middle !important;
}

.reserva-badge {
  white-space: normal;
  line-height: 1.2;
}

@media (max-width: 1199.98px) {
  .search-pill-responsive {
    flex-basis: 100%;
    margin-right: 0 !important;
  }
}

@media (max-width: 991.98px) {
  .list-header-actions {
    align-items: stretch !important;
  }

  .search-pill-responsive {
    border-radius: 1.1rem !important;
    padding: 0.5rem !important;
  }

  .search-pill-segment {
    width: 100%;
    border-left: 0 !important;
    margin-right: 0 !important;
    padding: 0.25rem 0 !important;
  }

  .form-search-wrapper,
  .search-pill-date-wrapper,
  .search-pill-type-wrapper {
    flex-basis: 100%;
    min-width: 100%;
  }

  .search-pill-date-wrapper {
    justify-content: space-between;
  }

  .search-pill-date {
    min-width: 0;
  }

  .search-pill-type-wrapper :deep(.custom-select),
  .search-pill-type-wrapper :deep(select) {
    width: 100%;
  }

  .btn-filtrar-responsive,
  .btn-adicionar-responsive {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 575.98px) {
  .search-pill-date-wrapper {
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .search-pill-date {
    flex-basis: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/producao/producao-formula-processo/ProducaoFormulaProcessoListagem.vue